import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { HelpActionsService } from '@core/services/help-actions.service';
import { MenuActionsComponent } from '@shared/components/menu-actions/menu-actions.component';
import { TuiButton, TuiDropdown } from '@taiga-ui/core';
import { LocalePickerDropdownComponent } from '../locale-picker-dropdown/locale-picker-dropdown.component';
@Component({
  selector: 'pxc-header',
  imports: [TuiButton, TuiDropdown, MenuActionsComponent, LocalePickerDropdownComponent],
  providers: [HelpActionsService],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  helpActions = inject(HelpActionsService).getActions();
  readonly helpMenuOpen = signal(false);
}
